
export const SIDEBAR_PROPS = {
  SIDEBAR_CLOSE_WIDTH: '4.5rem',
  SIDEBAR_OPEN_WIDTH: '20rem',
  SIDE_BAR_Z_INDEX: 1000,
  SIDEBAR_BACKGROUND_COLOR: '#eee',
};
